(function ($, app) {
    if (!$) {
        return;
    }

    app.core = {
        enhance(context) {
            const $context = context ? $(context) : $(document);

            if ($.fn.select2) {
                $context.find('select').each(function () {
                    const $select = $(this);

                    if (!$select.data('select2')) {
                        $select.select2({
                            width: '100%',
                            dropdownParent: $select.closest('.modal').length ? $('#commonModal') : $(document.body),
                        });
                    }
                });
            }

            if (window.flatpickr) {
                $context.find('.js-datepicker').flatpickr({ dateFormat: 'Y-m-d' });
            }

            if ($.fn.daterangepicker) {
                $context.find('.js-date-range').each(function () {
                    const $input = $(this);

                    if ($input.data('daterangepicker')) {
                        return;
                    }

                    $input.daterangepicker({
                        autoUpdateInput: false,
                        locale: { cancelLabel: 'Clear', format: 'YYYY-MM-DD' },
                    });

                    $input.on('apply.daterangepicker', function (event, picker) {
                        const $form = $input.closest('form');
                        $input.val(`${picker.startDate.format('YYYY-MM-DD')} - ${picker.endDate.format('YYYY-MM-DD')}`);
                        $form.find('[name="date_from"]').val(picker.startDate.format('YYYY-MM-DD'));
                        $form.find('[name="date_to"]').val(picker.endDate.format('YYYY-MM-DD'));
                    });

                    $input.on('cancel.daterangepicker', function () {
                        const $form = $input.closest('form');
                        $input.val('');
                        $form.find('[name="date_from"], [name="date_to"]').val('');
                    });
                });
            }

            app.helpers.refreshIcons();
        },
    };

    $(document).on('click', '.js-sidebar-toggle', function () {
        const $shell = $('.app-shell');
        const current = $shell.attr('data-sidebar-state') || 'expanded';
        const next = current === 'expanded' ? 'collapsed' : 'expanded';

        $shell.attr('data-sidebar-state', next);
        localStorage.setItem('itconnect.sidebar.state', next);
        window.setTimeout(() => app.datatable?.adjust(), 280);
    });

    $(document).on('click', '.js-submenu-toggle', function () {
        const $button = $(this);
        const $item = $button.closest('.has-children');
        const isOpen = $item.hasClass('is-submenu-open');

        $item.toggleClass('is-submenu-open', !isOpen);
        $button.attr('aria-expanded', isOpen ? 'false' : 'true');
    });
})(window.jQuery, window.ITConnect);
